import React from 'react';

const MenuCounter = ({ className, children }) => {
  return <div className={className}>{children}</div>;
};

export default MenuCounter;
